import axios from "axios";
import {
    Status
} from "../models/status";

class StatusWebservice {

    public async getAllStatus(): Promise<Array<Status> >{
        return await axios.get('/getAllStatus').then(function (response) {
            let status:Array<Status> = response.data
            return Promise.resolve(status)
        }).catch(function (error) {
            return Promise.reject([])
        })
    }
}

export const statusWebservice = new StatusWebservice();


// WEBPACK FOOTER //
// ./src/webservices/status.ts